import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughIntegration(): JSX.Element {
  return (
    <Text.Paragraph>
      Integration · Automation visited integration node.
    </Text.Paragraph>
  );
}
